import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
//todo finish styles

const QuestionLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
`;

const Select = styled.select`
  border: 1px solid #eee;
  background: #fff;
  padding: 11px 20px;
  width: 100%;
  margin: 15px 0;
  border-radius: 4px;
  font-size: 16px;
`;

export default function SingleSelectGroup({ options, name, label }) {
  return (
    <div>
      <QuestionLabel>{label}</QuestionLabel>

      <Select>
        <option value="0" className="invalid">
          Choose One
        </option>

        {options.map(({ value, label }) => {
          const key = `${name}_${value}`;
          return (
            <option key={key} value={value}>
              {label}
            </option>
          );
        })}
      </Select>
    </div>
  );
}

SingleSelectGroup.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string
};
